import util from '@bmp-vue/core/api/util'
const controller = 'v1.0/Empresa'
export default Object.assign({}, util.GetCrud(controller, null), {
})
